import {Text} from '@dropbox/dig-components/typography';
import {analyticsLogger} from 'analytics/analyticsLogger';
import allHandsGif from 'assets/images/home_allhands.gif';
import focusGif from 'assets/images/home_focus.svg';
import osnameImage from 'assets/images/home_osname.png';
import qbrGif from 'assets/images/home_qbr.gif';
import hw2025Logo from 'assets/images/hw2025Logo.png';
import soapboxLogo from 'assets/images/soapbox_logo.png';
import {ButtonLink} from 'components/DSYS/Link';

import styles from './Banner.module.css';
import {BannerConfig} from './BannerConfig';

export const BANNER_CONFIGS = {
  allhands: new BannerConfig({
    type: 'allhands',
    title: 'Company All Hands',
    image: allHandsGif,
    calendarRegex: 'Company All Hands',
    excludeContractor: true,
    background: 'linear-gradient(90deg, #EE6030 44.09%, rgba(244, 108, 66, 0.1) 100%)',
  }),
  focus: new BannerConfig({
    type: 'focus',
    title: 'Company Focus Day',
    image: focusGif,
    imageBackground: 'linear-gradient(270deg, #6DC7E9 0.18%, #FFFFFF 99.82%)',
    calendarRegex: 'Company Focus Day - NAMER time zone',
    isSingleDayEvent: true,
    marqueeText: 'make space for focus',
    subtitle: (
      <>
        Please reschedule meetings if possible for <Text isBold>today&apos;s focus day</Text>
      </>
    ),
    background: 'linear-gradient(90deg, #6DC7E9 44.09%, rgba(109, 199, 233, 0) 100%)',
  }),
  qbr: new BannerConfig({
    type: 'qbr',
    title: 'Quarterly Biz Review',
    excludeContractor: true,
    image: qbrGif,
    calendarRegex: 'Company QBR',
    background: 'linear-gradient(90deg, #BCDA4F 44.09%, rgba(187, 219, 76, 0) 100%)',
  }),
  soapbox: new BannerConfig({
    type: 'soapbox',
    title: 'Q2 Soapbox survey is here',
    image: soapboxLogo,
    imageBackground: 'linear-gradient(135deg, #FDF2FF 0%, #E4C3FF 50%, #B68EFF 100%)',
    calendarRegex: 'Soapbox',
    excludeContractor: true,
    subtitle: (
      <>
        <ButtonLink
          className={styles.buttonLink}
          variant="transparent"
          to="https://mail.google.com/mail/u/0/#search/from%3Aglint.mail.microsoft"
          onClick={() => analyticsLogger().logEvent('HOME_BANNER_CLICKED', {type: 'soapbox'})}
        >
          Take the survey
        </ButtonLink>
      </>
    ),
    background: 'linear-gradient(135deg, #FDF2FF 0%, #E4C3FF 50%, #B68EFF 100%)',
  }),
  hw2025: new BannerConfig({
    type: 'hw2025',
    title: 'Hack Week 2025',
    image: hw2025Logo,
    imageBackground: 'linear-gradient(135deg, #FEFCD7 0%, #FFF88A 50%, #FBE84C 100%)',
    calendarRegex: 'Hack Week 2025',
    excludeContractor: true,
    isSingleDayEvent: true,
    marqueeText: 'keep it simple',
    subtitle: (
      <>
        What are you hacking on this week?{' '}
        <ButtonLink
          className={styles.buttonLink}
          variant="transparent"
          to="https://app.dropboxer.net/hackdash/2025/projects/recent"
          onClick={() => analyticsLogger().logEvent('HOME_BANNER_CLICKED', {type: 'hw2025'})}
        >
          Open Hackdash
        </ButtonLink>
      </>
    ),
    background: 'linear-gradient(135deg, #FEFCD7 0%, #FFF88A 50%, #FBE84C 100%)',
  }),
  osname: new BannerConfig({
    type: 'osname',
    title: 'We need a new name',
    image: osnameImage,
    imageBackground: '#AED4EE',
    calendarRegex: 'CompanyOS rename',
    isSingleDayEvent: true,
    marqueeText: 'name our intranet',
    dismissible: false,
    subtitle: (
      <>
        CompanyOS is becoming our intranet.{' '}
        <ButtonLink
          className={styles.buttonLink}
          variant="transparent"
          to="https://dropbox.slack.com/archives/C0ARFB71TNG/p1792516941374259"
          onClick={() => analyticsLogger().logEvent('HOME_BANNER_CLICKED', {type: 'osname'})}
        >
          Submit your ideas
        </ButtonLink>{' '}
        in #barrierbusters by <Text isBold>Friday, Oct 23</Text>
      </>
    ),
    background: 'linear-gradient(90deg, #AED4EE 44.09%, rgba(174, 212, 238, 0) 100%)',
  }),
};
